import { HttpParams } from '@angular/common/http';
import * as qs from 'qs';

const defaultOptions: qs.IStringifyOptions<true> = {
  indices: false,
  arrayFormat: 'repeat',
  skipNulls: true,
  // having filter bypasses serialize date so have to serialize date here.
  filter: (_prefix, value) => (value === '' ? undefined : value instanceof Date ? value.toISOString() : value),
  serializeDate: (date: Date) => date.toISOString(),
};

// eslint-disable-next-line no-restricted-syntax -- qs.stringify serialises any plain value; narrowing here would push a cast onto every caller
export function httpParamMapper(params: unknown, options: qs.IStringifyOptions<true> = {}): HttpParams | undefined {
  if (!params) {
    return undefined;
  }
  const query = qs.stringify(params, { ...defaultOptions, ...options });
  return new HttpParams({ fromString: query });
}
